import React from "react";
import {
  Input,
  message,
  Button,
  Space,
  Row,
  Col,
  Tooltip,
  Modal,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import StaffStore from "../store/StaffStore";
import CompanyStore from "../store/CompanyStore";
import StaffAdd from "./StaffAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class CompanyBlackListPersonList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.onDelete = this.onDelete.bind(this);

    this.staffStore = new StaffStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId_value_label: "",
      salesPersonName: "",
      openStaffDetailsForm: false,
      staffId: "",
      listDataUpdate: false,

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "Sales Person Id",
        title: context.translate("_Id_"),
        dataIndex: "id",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Name",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_NAME_"),
        dataIndex: "name",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("companystafflist") && this.onEdit(record);
              }}
            >
              {value}
            </Link>
          );
        },
      },
      {
        // title: "Mobile No",
        title: context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_MOBILE_"),
        dataIndex: "mobileno",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Address",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_ADDRESS_"),
        dataIndex: "address",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Company",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_COMPANY_"),
        dataIndex: "companyName",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
        render: (companyName) => (
          <Tooltip placement="topLeft" title={companyName}>
            {companyName}
          </Tooltip>
        ),
      },
      {
        // title: "Employee Type",
        title: context.translate("_EMPLOYEE_TYPE_"),
        dataIndex: "salesPersonTypeId",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
        render: (mainValue) => {
          let value = Number(mainValue);
          if (value === 1) {
            return "Sales Executive";
          } else if (value === 2) {
            return "Sales Co-ordinator";
          } else if (value === 3) {
            return "Transport Co-ordinator";
          } else if (value === 7) {
            return "Bus Attendant";
          } else if (value === 8) {
            return "Teacher";
          } else if (value === 9) {
            return "Operations";
          }
        },
      },
      {
        // title: "Department",
        title: context.translate("_DEPARTMENT_"),
        dataIndex: "departmentName",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Employee Id",
        title: context.translate("_EMPLOYEE_ID_"),
        dataIndex: "employeeId",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Employee Status",
        title: context.translate("_EMPLOYEE_STATUS_"),
        dataIndex: "Employementstatus",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Working Hours",
        title: context.translate("_WORKING_HOUR_"),
        dataIndex: "workingHours",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Overtime Charges",
        title: context.translate("_OVERTIME_CHARGE_"),
        dataIndex: "overtimeCharges",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Other Permit",
        title: context.translate("_OTHER_PERMIT_"),
        dataIndex: "otherPermit",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Permit Number",
        title: context.translate("_PERMIT_NO_"),
        dataIndex: "permitNo",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Action",
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("companystafflist") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("companystafflist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer",width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];
  }
  onEdit = async (record) => {
    console.log(record.id, "re");
    await this.context.viewStateStore.setStaffStates({
      companyId: this.state.companyId,
      searchText: this.state.salesPersonName,
    });
    await this.context.viewStateStore.setStaffStates({
      companyId: this.state.companyId,
    });
    await this.setState({ staffId: record.id });
    await this.setState({ openStaffDetailsForm: true });
    // await this.props.navigate("/staffadd/" + record.id);
  };
  async onDelete(record) {
    console.log(record.id);
    const response = await this.staffStore.deleteRecord({
      id: record.id,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const staffStates = this.context.viewStateStore.staffStateObject;
      const singleData = await this.companyStore.getCompanyDataById(
        staffStates.companyId
      );
      await this.setState({
        companyId_value_label: singleData,
        salesPersonName: staffStates.searchText,
        companyId: staffStates.companyId,
      });

      console.log(staffStates);
      await this.staffStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: staffStates.companyId,
        salesPersonName: staffStates.searchText,
        isadmin: this.props.getUserData().isadmin,
      });
      await this.setState({ listDataUpdate: false });
      // await this.setState({salesPersonName:staffStates.searchText,})
    }
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      //  console.log(this.state.companyId)
      // await this.setState({userId:this.props.getUserData().userId})
      await this.handleSearch();
    }

    // await this.staffStore.loadData({ offset: 0, limit: 50 });
    this.setState({ pageSize: 50 });
    // await this.handleSearch();

    // await this.setState({ listUpdated: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ currentPage: 1, companyId: comp.value });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyId_value_label: singleData });
    await this.handleSearch();
  }

  async searchInput(e) {
    const searchField = e.target.value;
    this.setState({ salesPersonName: searchField });
    if (searchField.length > 2 || searchField.length === 0) {
      await this.staffStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId_value_label
          ? this.state.companyId_value_label[0].value
          : this.state.companyId,
        salesPersonName: searchField,
      });
      await this.setState({ listUpdated: 1 });
    }
  }
  async handleSearch(e) {
    this.setState({ loading: true });
    await this.staffStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      salesPersonName: this.state.salesPersonName,
      isadmin: this.props.getUserData().isadmin,
    });
    await this.setState({ listUpdated: 1 });

    //need to reload data
  }
  responseMsg = async (response) => {
    if (response?.success === "S") {
      message.success(response.message);
      // this.props.navigate("/companystafflist");
      await this.setState({ listDataUpdate: true });
      await this.setState({ openStaffDetailsForm: false });
    } else {
      message.error(response.errors[0].username);
    }
  };
  closeModal = () => {
    this.setState({ openStaffDetailsForm: false, driverId: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.staffStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        salesPersonName: "",
      });
    }
    this.setState({ loading: false, currentPage: 1, salesPersonName: "" });
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  value={
                    this.state.companyId_value_label !== ""
                      ? this.state.companyId_value_label
                      : null
                  }
                  onChange={this.handleChange}
                  // allowClear={true}
                  style={{ width: 200 }}
                />

                <Input
                  // placeholder="Sales Person Name"
                  placeholder={this.context.translate("_SALES_PERSON_NAME_")}
                  style={{ width: 200, borderRadius: "25px" }}
                  value={
                    this.state.salesPersonName !== ""
                      ? this.state.salesPersonName
                      : ""
                  }
                  onChange={async (e) => {
                    await this.searchInput(e);
                  }}
                ></Input>
                {/* <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={() => {
                    this.handleSearch();
                  }}
                /> */}
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              {this.props.canCreate("companystafflist") && (
                <Button
                  className="addButtonClass"
                  onClick={() => {
                    this.setState({
                      openStaffDetailsForm: true,
                      staffId: "",
                    });
                  }}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>

          <ListTable
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.staffStore?.total}
            columns={this.columns}
            dataSource={this.staffStore?.staff}
            loading={this.staffStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openStaffDetailsForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openStaffDetailsForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_EMPLOYEE_DETAILS_")}
                <p className="formDescription">
                  {this.context.translate("_EMPLOYEE_ADD_FORM_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openStaffDetailsForm: false })}
            onCancel={() =>
              this.setState({ openStaffDetailsForm: false, driverId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <StaffAdd
                staffId={this.state.staffId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
CompanyBlackListPersonList.contextType = StoreContext;
export default observer(withRouter(CompanyBlackListPersonList));
